import { render, staticRenderFns } from "./branchPanel.vue?vue&type=template&id=44f0e2ee&scoped=true&"
import script from "./branchPanel.vue?vue&type=script&lang=js&"
export * from "./branchPanel.vue?vue&type=script&lang=js&"
import style0 from "./branchPanel.vue?vue&type=style&index=0&id=44f0e2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f0e2ee",
  null
  
)

export default component.exports